import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const FolderRedirectLoader: LoadableType<{
	contentId: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FolderRedirect" */ '../src/FolderLanding/FolderRedirect.tsx'
			)
		).FolderRedirect,
});
